import { render, staticRenderFns } from "./SellerContact.vue?vue&type=template&id=e5815f06&"
import script from "./SellerContact.vue?vue&type=script&lang=js&"
export * from "./SellerContact.vue?vue&type=script&lang=js&"
import style0 from "./SellerContact.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports